import styled, { css } from 'styled-components'

export const PrintHeroImage = styled.img`
  width: 100%;
  height: 350px;
  max-height: 350px;
  object-fit: cover;
  display: block;
`

export const GalleryWrapper = styled.div<{ $printMode?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  ${({ $printMode }) =>
    $printMode &&
    css`
      @media print {
        display: none;
      }
    `}
`

export const PrintModeWrapper = styled.div<{ $printMode?: boolean }>`
  ${({ $printMode }) =>
    $printMode &&
    css`
      /* Tighter padding for print mode */
      padding: 0;

      /* Hide interactive elements */
      .action-buttons,
      .close-button,
      .resize-handle,
      .map-controls,
      .mapboxgl-ctrl-group,
      .mapboxgl-ctrl-attrib,
      .mapboxgl-ctrl-logo {
        display: none !important;
      }

      /* Tighter spacing for sections */
      section {
        margin-bottom: 12px;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      /* Reduce padding in content areas */
      > div {
        padding: 12px 16px;
      }

      /* Static map in print mode */
      [class*='MapPreview'] {
        pointer-events: none;
      }

      /* Add spacing after description in print mode */
      [class*='Description'] {
        margin-bottom: 16px;
      }

      /* Prevent page breaks inside content sections */
      [class*='QuickInfo'],
      [class*='PriceHistory'],
      [class*='PropertyDetails'],
      [class*='FeaturesList'],
      [class*='Description'],
      [class*='ContactCard'],
      [class*='PlatformsCard'],
      [class*='MetricsDisplay'] {
        break-inside: avoid;
        page-break-inside: avoid;
      }
    `}
`
